import React, { FunctionComponent, useEffect } from "react"

interface AdvantagesSectionProps {}

interface OpacityHandlerInterface {
  highestOpacityTxtIndex: number
  allElements: ChildNode[] | any
}

const AdvantagesSection: FunctionComponent<AdvantagesSectionProps> = () => {
  useEffect(() => {
    const opacityHandler = ({
      highestOpacityTxtIndex,
      allElements,
    }: OpacityHandlerInterface) => {
      const eleLength = allElements.length
      let count = 1

      // Set the center element opacity 100%
      allElements[highestOpacityTxtIndex].style.opacity = 1

      // Decrease the opacity of the other elements spreading outward from the center index
      while (
        highestOpacityTxtIndex - count >= 0 ||
        highestOpacityTxtIndex + count < eleLength
      ) {
        const lowerIndex = highestOpacityTxtIndex - count
        const higherIndex = highestOpacityTxtIndex + count

        if (allElements?.[lowerIndex]) {
          allElements[lowerIndex].style.opacity = `${0.9 - 0.15 * count}`
        }

        if (allElements?.[higherIndex]) {
          allElements[higherIndex].style.opacity = `${0.9 - 0.15 * count}`
        }

        count++
      }

      return
    }

    /* Scroll handler for the light blue section */
    const scrollHandler = () => {
      const advantagesSection = document.querySelector(
        ".advantages-section div"
      )
      const windowInnerHeight = window?.innerHeight
      const advantageTextHeight =
        advantagesSection?.childNodes[0]?.getBoundingClientRect()?.height

      const windowCenterRangerLower =
        (windowInnerHeight - advantageTextHeight) / 2
      const windowCenterRangerHigher =
        (windowInnerHeight + advantageTextHeight) / 2

      advantagesSection?.childNodes?.forEach((ele, index) => {
        let eleCoordinates = ele?.getBoundingClientRect()

        if (
          windowCenterRangerLower <= eleCoordinates.top &&
          windowCenterRangerHigher >= eleCoordinates.top
        ) {
          opacityHandler({
            highestOpacityTxtIndex: index,
            allElements: Array.from(advantagesSection.childNodes),
          })
        }
      })
    }

    document.addEventListener("scroll", scrollHandler)

    return () => {
      document.removeEventListener("scroll", scrollHandler)
    }
  }, [])

  return (
    <div className="advantages-section">
      <div className="h1Text">
        <div>No installing.</div>

        <div>No signup</div>

        <div>No ads.</div>

        <div>No work.</div>

        <div>No boring.</div>
      </div>
    </div>
  )
}

export default AdvantagesSection
